/**
 * 직원 피드백 반영 현황 — 홈과 로그인 안내 모달이 <b>같이 쓰는 단일 출처</b>.
 *
 * 왜 한곳에 모았나
 *   예전엔 DashboardPage(홈)와 LoginAnnouncementModal 이 각자 목록을 하드코딩하고,
 *   "두 곳을 같이 갱신할 것" 이라는 주석으로 버텼다. 실제로 한쪽만 고쳐져서
 *   모달은 3건이라는데 홈은 8건을 보여주는 상태가 됐다. 공지가 서로 다른 말을 하면
 *   그건 안 고친 것보다 나쁘다 — 어느 쪽을 믿어야 할지 알 수 없기 때문이다.
 *
 * 갱신 규칙
 *   피드백 게시판(/feedback)의 상태와 같은 목록을 유지한다.
 *   보드에서 '완료' 로 옮기면 여기서도 PENDING → DONE 으로 옮긴다.
 *
 * PENDING 의 eta 배지
 *   날짜가 잡힌 것은 그 일정("다음 주 중"), 지금 손대고 있는 것은 "진행 중" 을 단다.
 *   한 칸에 섞여 있어도 어느 쪽인지 한눈에 갈리도록.
 */

/** 반영 완료 — 피드백 게시판의 '완료' 항목. */
export const FEEDBACK_DONE = [
    {
        name: "일정 읽기 전용 팝업",
        desc: "일정을 열 때 편집창이 아니라 읽기 전용 팝업으로 뜨도록 변경했습니다.",
    },
    {
        name: "채널 탭 캘린더 일정 수정",
        desc: "프로젝트 채널 탭 안의 일정을 삭제뿐 아니라 수정도 할 수 있습니다.",
    },
    {
        name: "제안서 목록 UI",
        desc: "제안서 검색 결과를 한 줄에 2개씩 배치해 썸네일을 더 크게 확인할 수 있습니다.",
    },
    {
        name: "결재 작성하기",
        desc: "지출품의 결재를 올리는 방식을 정리하고 있습니다.",
    },
    {
        name: "키워드 등록 글자수 제한",
        desc: "키비주얼 업로드 시 한 글자 키워드도 등록되도록 글자수 제한을 완화합니다.",
        eta: "진행 중",
    },
    {
        name: "결재 양식 추가",
        desc: "기존 메일플러그·비즈메카에서 쓰던 결재 양식을 추가합니다.",
        eta: "진행 중",
    },
    { name: "알람", desc: "모바일 PC 등으로 알람", eta: "이번주 이내" },
    { name: "차계부", desc: "시스템 팀을 위한 차계부", eta: "이번주 이내" },

];

/** 진행 중 · 예정 — 피드백 게시판의 '진행중' 항목 + 일정이 잡힌 예정 작업. */
export const FEEDBACK_PENDING = [
    { name: "실행팀 체크리스트", desc: "실행팀 업무 체크리스트", eta: "다음 주 중" },
    { name: "업무 요청서", desc: "전 부서 대상 업무 요청·접수", eta: "다음 주 중" },
    { name: "대시보드", desc: "부서별로 필요한 항목을 취합해 구성", eta: "2주 이내" },
];

/**
 * 메일 시스템 복구 안내 — 홈·모달이 같은 문구로 알린다.
 *
 * 지금 당장 직원의 행동이 바뀌는 유일한 항목이라(메일플러그를 더는 쓰지 않는다),
 * 피드백 목록에 한 줄로 섞지 않고 별도 배너로 띄운다.
 */
export const MAIL_RESTORE_NOTICE = {
    title: "메일 시스템 복구가 완료되었습니다.",
    lines: [
        "이제부터는 메일플러그 대신 좌측 ‘메일’ 메뉴를 사용하시면 됩니다.",
        "기존 메일함은 받은·보낸·스팸·임시보관함은 물론 직접 만드신 분류 폴더까지 그대로 옮겨져 있습니다.",
        "혹시 빠진 메일이 있다면 ‘외부 이메일 가져오기’ 메뉴에서 백업 파일을 직접 올리실 수 있습니다.",
    ],
};
